(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4309],{

/***/ 13635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EQ": function() { return /* binding */ showCompareError; },
/* harmony export */   "d4": function() { return /* binding */ replaceCompareProduct; },
/* harmony export */   "p2": function() { return /* binding */ getCompareData; },
/* harmony export */   "vH": function() { return /* binding */ addRemoveProductToCompare; },
/* harmony export */   "xQ": function() { return /* binding */ removeCompareProducts; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1369);
/* harmony import */ var _commonAction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88093);
/* harmony import */ var _services_productListService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98776);





var addRemoveProductToCompare = function addRemoveProductToCompare(isSelected, product) {
  return function (dispatch) {
    if (isSelected) {
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .ADD_COMPARE_PRODUCT */ .Ov,
        payload: product
      });
    } else {
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .REMOVE_COMPARE_PRODUCT */ .Fu,
        payload: product
      });
    }
  };
};
var removeCompareProducts = function removeCompareProducts() {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .REMOVE_ALL */ .Vo
    });
  };
};
var showCompareError = function showCompareError(errMsg) {
  return function (dispatch) {
    dispatch({
      type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .SHOW_COMPARE_ERROR */ .j_,
      payload: errMsg
    });
  };
};
var getCompareData = function getCompareData() {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch) {
      var result;
      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              (0,_commonAction__WEBPACK_IMPORTED_MODULE_1__/* .setLoadingStatus */ .h)(true, dispatch);
              _context.next = 4;
              return (0,_services_productListService__WEBPACK_IMPORTED_MODULE_2__/* .getProductCompareList */ .iK)(ids);

            case 4:
              result = _context.sent;
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .PRODUCT_COMPARE_LIST */ .bn,
                payload: result
              });
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              (0,_commonAction__WEBPACK_IMPORTED_MODULE_1__/* .setLoadingStatus */ .h)(false, dispatch);

            case 11:
              _context.prev = 11;
              (0,_commonAction__WEBPACK_IMPORTED_MODULE_1__/* .setLoadingStatus */ .h)(false, dispatch);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8, 11, 14]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var replaceCompareProduct = function replaceCompareProduct(previousItem, currentItem, isNewItemToCompare) {
  return function (dispatch) {
    var replaceObj = {
      previousItem: previousItem,
      currentItem: currentItem
    };

    if (isNewItemToCompare) {
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .ADD_COMPARE_PRODUCT */ .Ov,
        payload: currentItem
      });
    } else {
      dispatch({
        type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_3__/* .REPLACE_COMPARE_PRODUCT */ .Di,
        payload: replaceObj
      });
    }
  };
};

/***/ }),

/***/ 33757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ button_ButtonComponent; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
// EXTERNAL MODULE: ./config/fonts.js
var fonts = __webpack_require__(78198);
;// CONCATENATED MODULE: ./components/atoms/button/ButtonComponentStyle.js


var ButtonComponentStyle = [".buttonText.jsx-1048313388{font-family:".concat(fonts/* default.medium */.Z.medium, ";font-weight:500;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;text-align:center;color:").concat(colors/* default.Black23 */.Z.Black23, ";cursor:pointer;}"), ".transparant-btn.jsx-1048313388{background:none;border:none;outline:none;}", ".image-box.jsx-1048313388{padding-right:8px;}", ".button-hide.jsx-1048313388{display:none;}", ".btnTextSizingMobile.jsx-1048313388{font-size:14px;}", ".out-of-stock-disabled-btn.jsx-1048313388{color:".concat(colors/* default.Grey20 */.Z.Grey20, ";!important;}")];
ButtonComponentStyle.__hash = "1048313388";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/button/ButtonComponent.js







var ButtonComponent = function ButtonComponent(props) {
  /*
   The following function "buttonClicked" handles the event Button click.
   Implementation yet to be added
    */
  var buttonClicked = function buttonClicked(e) {
    if (props.onBtnClick) {
      e.preventDefault();
      props.onBtnClick(e);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      id: props.id,
      uniquebuttonid: props === null || props === void 0 ? void 0 : props.uniqueButtonId,
      onClick: function onClick(e) {
        buttonClicked(e);
      },
      disabled: props === null || props === void 0 ? void 0 : props.disabledFlag,
      className: "jsx-".concat(ButtonComponentStyle.__hash) + " " + ((props !== null && props !== void 0 && props.isHidden ? "button-hide" : "".concat(props === null || props === void 0 ? void 0 : props.className)) || ""),
      children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        id: props === null || props === void 0 ? void 0 : props.uniqueButtonId,
        className: "jsx-".concat(ButtonComponentStyle.__hash) + " " + "".concat(props.textClassName, " ").concat(props.background, " ").concat(props === null || props === void 0 ? void 0 : props.disabledBtnClassName, " buttonText"),
        children: props.selected ? props.selectedText : props.text
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: ButtonComponentStyle.__hash,
      children: ButtonComponentStyle
    })]
  });
};

ButtonComponent.defaultProps = {
  pageRequired: "/",
  className: "transparant-btn"
};
/* harmony default export */ var button_ButtonComponent = (ButtonComponent);

/***/ }),

/***/ 87419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ imageWithText_ImageWithText; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(77521);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./config/colors.js
var colors = __webpack_require__(93957);
;// CONCATENATED MODULE: ./components/atoms/imageWithText/imageWithTextStyle.js

var imageWithTextStyle = [".card.jsx-3853968429{padding:1rem;margin:0.7rem 1rem;}", ".text-center.jsx-3853968429{text-align:center;}", ".image-title.jsx-3853968429{height:2.75rem;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;}", ".title.jsx-3853968429{font-size:1rem;line-height:1.375rem;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;color:#08081B;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;}", ".image.jsx-3853968429{display:block;width:11.25rem;height:11.25rem;margin:auto;object-fit:contain;}", ".custom-image.jsx-3853968429{display:block margin:0 auto;object-fit:contain;background-size:cover;}", ".custom-image-section.jsx-3853968429{background-size:contain;background-repeat:no-repeat;background-position:center;margin:0 auto;}", ".color-label.jsx-3853968429{color:".concat(colors/* default.Grey60 */.Z.Grey60, ";font-family:Roboto Regular;font-size:0.875rem;font-weight:normal;font-stretch:normal;font-style:normal;line-height:normal;-webkit-letter-spacing:normal;-moz-letter-spacing:normal;-ms-letter-spacing:normal;letter-spacing:normal;text-align:center;}")];
imageWithTextStyle.__hash = "3853968429";
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/imageWithText/ImageWithText.js







var ImageWithText = function ImageWithText(props) {
  var labelText = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    var _labelText$current;

    if ((labelText === null || labelText === void 0 ? void 0 : (_labelText$current = labelText.current) === null || _labelText$current === void 0 ? void 0 : _labelText$current.scrollHeight) !== null) {
      while ((labelText === null || labelText === void 0 ? void 0 : (_labelText$current2 = labelText.current) === null || _labelText$current2 === void 0 ? void 0 : _labelText$current2.scrollHeight) > (labelText === null || labelText === void 0 ? void 0 : (_labelText$current3 = labelText.current) === null || _labelText$current3 === void 0 ? void 0 : _labelText$current3.offsetHeight)) {
        var _labelText$current2, _labelText$current3;

        labelText.current.innerText = labelText.current.innerText.replace(/\W*\s(\S)*$/, '...');
      }
    }
  }, [labelText]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "text-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      style: {
        width: props.width,
        height: props.height,
        backgroundImage: "url(".concat(props.img_path, ")")
      },
      className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "mw-100 custom-image-section"
    }), props.children ? props.children : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "image-title mt-s",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
        ref: labelText,
        dangerouslySetInnerHTML: (0,helperServices/* createMarkup */.KU)(props.text),
        uniqueName: props.uniqueName,
        className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "title mt-auto ".concat(props.imageLabelStyle)
      })
    }), props !== null && props !== void 0 && props.color ? /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
      className: "jsx-".concat(imageWithTextStyle.__hash) + " " + "color-label",
      children: props === null || props === void 0 ? void 0 : props.color
    }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)((style_default()), {
      id: imageWithTextStyle.__hash,
      children: imageWithTextStyle
    })]
  });
};

/* harmony default export */ var imageWithText_ImageWithText = (ImageWithText);

/***/ }),

/***/ 96105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var Timer = function Timer(_ref) {
  var onTimerComplete = _ref.onTimerComplete,
      dateTime = _ref.dateTime,
      preText = _ref.preText,
      className = _ref.className;

  var handleChange = function handleChange(event) {
    onTimerComplete(event);
  };

  var renderer = function renderer(props) {
    if (props.completed) {
      handleChange(false);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    } else {
      handleChange(true);
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: className,
        children: [!!preText && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: preText
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.days
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "d "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.hours
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "h "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.minutes
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "m "
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: props.formatted.seconds
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "s"
        })]
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.Countdown, {
    date: dateTime,
    renderer: renderer,
    zeroPadTime: 1
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Timer);

/***/ }),

/***/ 14309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProductCards_ProductCards; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/molecules/ProductCards/ProductCards.module.scss
var ProductCards_module = __webpack_require__(57922);
var ProductCards_module_default = /*#__PURE__*/__webpack_require__.n(ProductCards_module);
// EXTERNAL MODULE: ./components/atoms/imageWithText/ImageWithText.js + 1 modules
var ImageWithText = __webpack_require__(87419);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
// EXTERNAL MODULE: ./components/atoms/switch/Switch.module.scss
var Switch_module = __webpack_require__(24236);
var Switch_module_default = /*#__PURE__*/__webpack_require__.n(Switch_module);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/switch/Switch.jsx





var Switch = function Switch(_ref) {
  var _ref$switchValues = _ref.switchValues,
      switchValues = _ref$switchValues === void 0 ? ['Monthly', 'Once-off'] : _ref$switchValues,
      handleFirst = _ref.handleFirst,
      handleSecond = _ref.handleSecond,
      btnfColor = _ref.btnfColor,
      btnSColor = _ref.btnSColor,
      variant = _ref.variant,
      className = _ref.className;

  var generateVariant = function generateVariant() {
    switch (variant) {
      case "product-carousel":
        return variant ? "".concat((Switch_module_default())["regular-switch--" + variant]) : "";

      default:
        return variant ? "".concat((Switch_module_default())["regular-switch--" + variant]) : "";
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
    className: "".concat((Switch_module_default())["regular-switch"], " ").concat(generateVariant(), " ").concat(className ? (Switch_module_default())[className] : ''),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      id: "main_price_switch_".concat(switchValues[0]),
      className: "".concat((Switch_module_default())["first-btn"], " ").concat(btnfColor ? (Switch_module_default())["btn-clicked"] : (Switch_module_default())["btn-not-clicked"], " "),
      onClick: handleFirst,
      children: switchValues[0]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      id: "main_price_switch_".concat(switchValues[1]),
      className: "".concat((Switch_module_default())["second-btn"], " ").concat(btnSColor ? (Switch_module_default())["btn-clicked"] : (Switch_module_default())["btn-not-clicked"]),
      onClick: handleSecond,
      children: switchValues[1]
    })]
  });
};

/* harmony default export */ var switch_Switch = (Switch);
// EXTERNAL MODULE: ./components/atoms/checkBox/Checkbox.js
var Checkbox = __webpack_require__(51707);
// EXTERNAL MODULE: ./components/atoms/button/ButtonComponent.js + 1 modules
var ButtonComponent = __webpack_require__(33757);
// EXTERNAL MODULE: ./components/atoms/image/image.jsx + 1 modules
var image_image = __webpack_require__(39489);
// EXTERNAL MODULE: ./components/atoms/infoText/InfoText.module.scss
var InfoText_module = __webpack_require__(51494);
var InfoText_module_default = /*#__PURE__*/__webpack_require__.n(InfoText_module);
;// CONCATENATED MODULE: ./components/atoms/infoText/InfoText.js





var InfoText = function InfoText(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "".concat((InfoText_module_default())["info-container"], " ").concat(props.className),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "".concat((InfoText_module_default())["info-text"]),
        children: props.text
      })
    })
  });
};

InfoText.defaultProps = {
  className: "",
  text: "Prepaid only"
};
/* harmony default export */ var infoText_InfoText = (InfoText);
// EXTERNAL MODULE: ./config/errorMessages.js
var errorMessages = __webpack_require__(72210);
// EXTERNAL MODULE: ./components/atoms/tag/Tag.jsx
var Tag = __webpack_require__(4648);
// EXTERNAL MODULE: ./Redux/actions/productCompareAction.js
var productCompareAction = __webpack_require__(13635);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./Redux/actions/cartAction.js
var cartAction = __webpack_require__(35311);
// EXTERNAL MODULE: ./components/atoms/timer/Timer.jsx
var Timer = __webpack_require__(96105);
// EXTERNAL MODULE: ./components/atoms/snackBar/SnackBar.jsx
var SnackBar = __webpack_require__(52932);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./Redux/actions/userProfileAction.js + 2 modules
var userProfileAction = __webpack_require__(15623);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
;// CONCATENATED MODULE: ./components/molecules/ProductCards/ProductCards.jsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



























var ProductCards = function ProductCards(props) {
  var _props$item2, _props$item19, _props$item20, _props$item21, _props$item22, _jsxs2;

  var _useState = (0,react.useState)(true),
      isTimerOn = _useState[0],
      setIsTimerOn = _useState[1];

  var handleTimerChange = function handleTimerChange(newValue) {
    setIsTimerOn(newValue);
  };

  var _getdealDatenVariant = (0,helperServices/* getdealDatenVariant */.H5)(props),
      _getdealDatenVariant2 = (0,slicedToArray/* default */.Z)(_getdealDatenVariant, 2),
      dateTime = _getdealDatenVariant2[0],
      dealVariant = _getdealDatenVariant2[1];

  var _useState2 = (0,react.useState)(props === null || props === void 0 ? void 0 : props.checked),
      checked = _useState2[0],
      setCheck = _useState2[1];

  var checkBoxHandler = function checkBoxHandler() {
    setCheck(checked = !checked);
    props === null || props === void 0 ? void 0 : props.checkBoxClickHandler(checked);
  };

  var _useState3 = (0,react.useState)(false),
      isAddedForCompare = _useState3[0],
      setIsAddedForCompare = _useState3[1];

  var _useState4 = (0,react.useState)(true),
      showCompareCheck = _useState4[0],
      setShowCompareCheck = _useState4[1];

  var _useState5 = (0,react.useState)(true),
      isMonthly = _useState5[0],
      setIsMonthly = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      isOnceOff = _useState6[0],
      setIsOnceOff = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      showSnackBar = _useState7[0],
      setShowSnackBar = _useState7[1];

  var _useState8 = (0,react.useState)(),
      colorAvailable = _useState8[0],
      setColorAvailable = _useState8[1];

  var env = (config_default()).env;
  var imagePrefix = (config_default()).envConfigs[env].imagePrefix;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;
  var router = (0,DependencyHelper.useRouter)();

  var btnfClicked = function btnfClicked() {
    setIsMonthly(true);
    setIsOnceOff(false);
    props.onPriceTypeChange({
      priceType: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
      product: _objectSpread(_objectSpread({}, props.item), {}, {
        salesProductPrice: props === null || props === void 0 ? void 0 : props.dealProductPrice
      })
    });
  };

  var btnsClicked = function btnsClicked() {
    setIsOnceOff(true);
    setIsMonthly(false);
    props.onPriceTypeChange({
      priceType: types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF,
      product: _objectSpread(_objectSpread({}, props.item), {}, {
        salesProductPrice: props === null || props === void 0 ? void 0 : props.minimumPrice
      })
    });
  };

  (0,react.useEffect)(function () {
    var _props$item, _props$item$configura, _props$item$configura2;

    var isColorSwatchesAvailable = props === null || props === void 0 ? void 0 : (_props$item = props.item) === null || _props$item === void 0 ? void 0 : (_props$item$configura = _props$item.configurable_options) === null || _props$item$configura === void 0 ? void 0 : (_props$item$configura2 = _props$item$configura[0]) === null || _props$item$configura2 === void 0 ? void 0 : _props$item$configura2.values;
    var colorAvailable = isColorSwatchesAvailable !== undefined && isColorSwatchesAvailable.map(function (colorItem) {
      var _colorItem$swatch_dat;

      return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
        style: {
          backgroundColor: "".concat(colorItem === null || colorItem === void 0 ? void 0 : (_colorItem$swatch_dat = colorItem.swatch_data) === null || _colorItem$swatch_dat === void 0 ? void 0 : _colorItem$swatch_dat.value)
        },
        className: (ProductCards_module_default()).color_swatch
      }, colorItem.value_index);
    });
    setColorAvailable(colorAvailable);
  }, [props === null || props === void 0 ? void 0 : (_props$item2 = props.item) === null || _props$item2 === void 0 ? void 0 : _props$item2.configurable_options]);
  (0,react.useEffect)(function () {
    setCheck(props === null || props === void 0 ? void 0 : props.checked);
  }, [props === null || props === void 0 ? void 0 : props.checked]);
  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.isMonthly) {
      setIsMonthly(true);
      setIsOnceOff(false);
    }
  }, [props === null || props === void 0 ? void 0 : props.isMonthly]);
  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.isOnceOff) {
      setIsOnceOff(true);
      setIsMonthly(false);
    }
  }, [props === null || props === void 0 ? void 0 : props.isOnceOff]);

  var getCustomDropDown = function getCustomDropDown() {
    var _props$item3, _props$item4;

    if (Array.isArray(props === null || props === void 0 ? void 0 : (_props$item3 = props.item) === null || _props$item3 === void 0 ? void 0 : _props$item3.options) && (props === null || props === void 0 ? void 0 : (_props$item4 = props.item) === null || _props$item4 === void 0 ? void 0 : _props$item4.options.length) > 0) {
      var customDropDown = props.item.options.find(function (option) {
        return option["__typename"] === labels/* default.lbl_custom_dropdown_typeName */.Z.lbl_custom_dropdown_typeName;
      });
      var prepaidOption = customDropDown === null || customDropDown === void 0 ? void 0 : customDropDown.value.find(function (option) {
        return option.sku === labels/* default.lbl_custom_dropdown_prepaid_option */.Z.lbl_custom_dropdown_prepaid_option;
      });
      return {
        option_id: customDropDown === null || customDropDown === void 0 ? void 0 : customDropDown.option_id,
        option_type_id: prepaidOption === null || prepaidOption === void 0 ? void 0 : prepaidOption.option_type_id
      };
    } else {
      return null;
    }
  };

  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.isAddtoCompare) {
      var compareFlag = false;

      if (props.productCompareList) {
        props.productCompareList.map(function (product) {
          if (product.sku === props.item.sku) {
            compareFlag = true;
          }
        });
      }

      setIsAddedForCompare(compareFlag);

      if (props.productCompareList && props.productCompareList.length > 0) {
        var compareObj = props.productCompareList[0];
        var len = compareObj.categories.length;

        var _loop = function _loop() {
          var sourceCategory = compareObj.categories[i];
          var isSameCategoryProduct = props.item.categories.filter(function (category) {
            return category.id === sourceCategory.id;
          });

          if (isSameCategoryProduct.length > 0) {
            setShowCompareCheck(true);
            return "break";
          } else {
            setShowCompareCheck(false);
          }
        };

        for (var i = 0; i < len; i++) {
          var _ret = _loop();

          if (_ret === "break") break;
        }

        if (len == 0 && props.productCompareList[0].sku !== props.item.sku) {
          setShowCompareCheck(false);
        }
      } else {
        setShowCompareCheck(true);
      }
    }
  }, [props === null || props === void 0 ? void 0 : props.productCompareList]);

  var checkValidation = function checkValidation(event, isChecked) {
    var isMobile = window.innerWidth < 768 ? true : false;

    if (props.productCompareList.length > 0 && isChecked) {
      if (isMobile && props.productCompareList.length === 2) {
        props.showCompareError("".concat(errorMessages/* default.compare_count_mobile_err */.Z.compare_count_mobile_err));

        if (event) {
          event.preventDefault();
        }

        setIsAddedForCompare(false);
      } else if (!isMobile && props.productCompareList.length === 3) {
        props.showCompareError("".concat(errorMessages/* default.compare_count_desktop_err */.Z.compare_count_desktop_err));

        if (event) {
          event.preventDefault();
        }

        setIsAddedForCompare(false);
      } else {
        props.addRemoveProductToCompare(isChecked, props.item);
        setIsAddedForCompare(isChecked);

        if (isChecked) {
          var _props$item5, _props$item5$categori, _props$item6;

          analyticsUtag/* link */.p4({
            page_tool_event: "use",
            page_tool_name: "shopping: product grid: add to compare",
            sales_product_category: [props === null || props === void 0 ? void 0 : (_props$item5 = props.item) === null || _props$item5 === void 0 ? void 0 : (_props$item5$categori = _props$item5.categories[0]) === null || _props$item5$categori === void 0 ? void 0 : _props$item5$categori.name],
            sales_product_id: [props === null || props === void 0 ? void 0 : (_props$item6 = props.item) === null || _props$item6 === void 0 ? void 0 : _props$item6.name],
            sales_product_price: getProductPrice() ? [getProductPrice()] : [props === null || props === void 0 ? void 0 : props.minimumPrice],
            sales_product_quantity: [1],
            sales_order_discount: [props === null || props === void 0 ? void 0 : props.amountOff]
          });
        }
      }
    } else {
      props.addRemoveProductToCompare(isChecked, props.item);
      setIsAddedForCompare(isChecked);

      if (isChecked) {
        var _props$item7, _props$item7$categori, _props$item8;

        analyticsUtag/* link */.p4({
          page_tool_event: "use",
          page_tool_name: "shopping: product grid: add to compare",
          sales_product_category: [props === null || props === void 0 ? void 0 : (_props$item7 = props.item) === null || _props$item7 === void 0 ? void 0 : (_props$item7$categori = _props$item7.categories[0]) === null || _props$item7$categori === void 0 ? void 0 : _props$item7$categori.name],
          sales_product_id: [props === null || props === void 0 ? void 0 : (_props$item8 = props.item) === null || _props$item8 === void 0 ? void 0 : _props$item8.name],
          sales_product_price: getProductPrice() ? [getProductPrice()] : [props === null || props === void 0 ? void 0 : props.minimumPrice],
          sales_product_quantity: [1],
          sales_order_discount: [props === null || props === void 0 ? void 0 : props.amountOff]
        });
      }
    }
  };

  var getProductPrice = function getProductPrice() {
    if (props !== null && props !== void 0 && props.finalPriceReq) {
      return props === null || props === void 0 ? void 0 : props.finalPrice;
    } else if (isOnceOff) {
      return props === null || props === void 0 ? void 0 : props.minimumPrice;
    }

    return props === null || props === void 0 ? void 0 : props.dealProductPrice;
  };

  var addCookieProductToCart = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _props$item9, _props$item9$categori, _props$item9$categori2, _props$item10, _values$option_type_i, _props$item11, _props$item13, _props$item14, _props$item15, _props$item16, _props$item17, _cartResult, _cartResult2, _cartResult3, _cartResult3$data, _cartResult4, _cartResult4$data, _cartResult5, _cartResult5$data;

      var cartId, cartArr, cartResult, analyticsData, values, customizable_options, _props$item12, _props$item18, _props$item18$bundleO, bundleOptions;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              props === null || props === void 0 ? void 0 : props.resetSyncUserProfile();
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              analyticsData = _objectSpread({
                sales_event: "cart_add",
                page_name: "shopping: cart",
                page_channel: "shopping",
                page_master_tab: "personal",
                sales_order_discount: [props === null || props === void 0 ? void 0 : props.amountOff],
                sales_product_category: [(props === null || props === void 0 ? void 0 : (_props$item9 = props.item) === null || _props$item9 === void 0 ? void 0 : (_props$item9$categori = _props$item9.categories) === null || _props$item9$categori === void 0 ? void 0 : (_props$item9$categori2 = _props$item9$categori[0]) === null || _props$item9$categori2 === void 0 ? void 0 : _props$item9$categori2.name) || ""],
                sales_product_id: [props === null || props === void 0 ? void 0 : (_props$item10 = props.item) === null || _props$item10 === void 0 ? void 0 : _props$item10.name],
                sales_product_price: [getProductPrice()],
                sales_product_quantity: [1]
              }, analyticsUtag/* getUtagData */.GS(["visitor_login_status", "visitor_subscription_type", "visitor_msisdn_hash", "visitor_id_hash"]));
              values = getCustomDropDown();
              customizable_options = values ? [{
                id: values === null || values === void 0 ? void 0 : values.option_id,
                value_string: values === null || values === void 0 ? void 0 : (_values$option_type_i = values.option_type_id) === null || _values$option_type_i === void 0 ? void 0 : _values$option_type_i.toString()
              }] : [];

              if (props !== null && props !== void 0 && (_props$item11 = props.item) !== null && _props$item11 !== void 0 && _props$item11.promotion_tag_label) {
                analyticsData.sales_promo_name = [props === null || props === void 0 ? void 0 : (_props$item12 = props.item) === null || _props$item12 === void 0 ? void 0 : _props$item12.promotion_tag_label];
              }

              if (!((props === null || props === void 0 ? void 0 : (_props$item13 = props.item) === null || _props$item13 === void 0 ? void 0 : _props$item13.__typename) === labels/* default.lbl_product_typeName_simple */.Z.lbl_product_typeName_simple && (props === null || props === void 0 ? void 0 : (_props$item14 = props.item) === null || _props$item14 === void 0 ? void 0 : _props$item14.stock_status) === labels/* default.lbl_in_stock */.Z.lbl_in_stock)) {
                _context.next = 13;
                break;
              }

              cartArr = [{
                data: {
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                  sku: props.sku
                },
                customizable_options: customizable_options
              }];
              _context.next = 11;
              return props.addSimpleProductToGuestCart(cartId, cartArr);

            case 11:
              cartResult = _context.sent;
              analyticsUtag/* link */.p4(analyticsData);

            case 13:
              if (!((props === null || props === void 0 ? void 0 : (_props$item15 = props.item) === null || _props$item15 === void 0 ? void 0 : _props$item15.__typename) === labels/* default.lbl_product_typeName_configurable */.Z.lbl_product_typeName_configurable)) {
                _context.next = 19;
                break;
              }

              cartArr = [{
                parent_sku: props === null || props === void 0 ? void 0 : props.sku,
                data: {
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                  sku: props === null || props === void 0 ? void 0 : props.variantSku
                },
                customizable_options: customizable_options
              }];
              _context.next = 17;
              return props.addConfigurableToGuestCart(cartId, cartArr);

            case 17:
              cartResult = _context.sent;
              analyticsUtag/* link */.p4(analyticsData);

            case 19:
              if (!((props === null || props === void 0 ? void 0 : (_props$item16 = props.item) === null || _props$item16 === void 0 ? void 0 : _props$item16.__typename) === labels/* default.lbl_product_type_bundle */.Z.lbl_product_type_bundle && (props === null || props === void 0 ? void 0 : (_props$item17 = props.item) === null || _props$item17 === void 0 ? void 0 : _props$item17.stock_status) === labels/* default.lbl_in_stock */.Z.lbl_in_stock)) {
                _context.next = 26;
                break;
              }

              bundleOptions = props === null || props === void 0 ? void 0 : (_props$item18 = props.item) === null || _props$item18 === void 0 ? void 0 : (_props$item18$bundleO = _props$item18.bundleOption) === null || _props$item18$bundleO === void 0 ? void 0 : _props$item18$bundleO.map(function (bundle) {
                var obj = {
                  id: bundle.option_id,
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty,
                  value: [bundle.options[0].id]
                };
                return obj;
              });
              cartArr = [{
                bundle_options: bundleOptions,
                data: {
                  sku: props.sku.toString(),
                  quantity: labels/* default.lbl_cart_min_product_add_qty */.Z.lbl_cart_min_product_add_qty
                },
                customizable_options: customizable_options
              }];
              _context.next = 24;
              return props.addBundleProductToGuestCart(cartId, cartArr);

            case 24:
              cartResult = _context.sent;
              analyticsUtag/* link */.p4(analyticsData);

            case 26:
              if (((_cartResult = cartResult) === null || _cartResult === void 0 ? void 0 : _cartResult.status) == 422 && props !== null && props !== void 0 && props.isCartPage) {
                (0,helperServices/* handleCartActionFailure */.rO)(cartResult, addCookieProductToCart, handleProfileSync);
              } else if (cartResult && !cartResult.errors && (!((_cartResult2 = cartResult) !== null && _cartResult2 !== void 0 && _cartResult2.data) || (_cartResult3 = cartResult) !== null && _cartResult3 !== void 0 && (_cartResult3$data = _cartResult3.data) !== null && _cartResult3$data !== void 0 && _cartResult3$data.addConfigurableProductsToCart || (_cartResult4 = cartResult) !== null && _cartResult4 !== void 0 && (_cartResult4$data = _cartResult4.data) !== null && _cartResult4$data !== void 0 && _cartResult4$data.addSimpleProductsToCart || (_cartResult5 = cartResult) !== null && _cartResult5 !== void 0 && (_cartResult5$data = _cartResult5.data) !== null && _cartResult5$data !== void 0 && _cartResult5$data.addBundleProductsToCart)) {
                (0,helperServices/* hideSpinner */.v3)();
                props === null || props === void 0 ? void 0 : props.setUpdateCartDetails("addedCartProduct");
                setShowSnackBar(true);
              } else {
                (0,helperServices/* hideSpinner */.v3)();
                props === null || props === void 0 ? void 0 : props.setUpdateCartDetails("addedCartProduct");
              }

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function addCookieProductToCart() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleProfileSync = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var JWTtoken, cartId, pageAction, dataResult, oAuthToken, _oAuthToken, getLoggedInCardId;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              JWTtoken = (0,helperServices/* getCookieValue */.Do)("vod-web-auth-token");
              cartId = (0,helperServices/* getCookieValue */.Do)("cart_id");
              pageAction = "productCards";
              _context2.next = 5;
              return props === null || props === void 0 ? void 0 : props.syncUserProfile({
                JWTtoken: JWTtoken,
                cartId: cartId,
                pageAction: pageAction
              });

            case 5:
              dataResult = _context2.sent;

              if (!(dataResult.type === actionTypes/* SYNC_USER_PROFILE_SUCCESS */.Zd)) {
                _context2.next = 20;
                break;
              }

              if (!(dataResult.requestPayload.cartId && dataResult.requestPayload.cartId.length)) {
                _context2.next = 12;
                break;
              }

              oAuthToken = (0,helperServices/* getAuthToken */.bW)(dataResult);

              if (oAuthToken) {
                addCookieProductToCart();
              }

              _context2.next = 18;
              break;

            case 12:
              _oAuthToken = (0,helperServices/* getAuthToken */.bW)(dataResult);

              if (!_oAuthToken) {
                _context2.next = 18;
                break;
              }

              _context2.next = 16;
              return (0,helperServices/* getCustomerActiveCartService */.t5)();

            case 16:
              getLoggedInCardId = _context2.sent;

              if (getLoggedInCardId && !getLoggedInCardId.fail && getLoggedInCardId.length) {
                (0,helperServices/* setCookieConsentWrapper */.ol)("cart_id", [(config_default()).cookie_category.strictly_necessary], "document.cookie='cart_id=".concat(getLoggedInCardId, ";path=/'"));
                addCookieProductToCart();
              }

            case 18:
              _context2.next = 22;
              break;

            case 20:
              props === null || props === void 0 ? void 0 : props.resetSyncUserProfile();
              (0,helperServices/* hideSpinner */.v3)();

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleProfileSync() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (props !== null && props !== void 0 && props.triggerCallback && (props === null || props === void 0 ? void 0 : props.triggerCallback) == true) {
      addCookieProductToCart();
    }
  }, [props === null || props === void 0 ? void 0 : props.triggerCallback]);

  var onProductClick = function onProductClick(event) {
    var _event$target, _event$target2, _event$target3, _event$target4, _event$target5, _event$target6, _event$target7;

    if ((event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.id) === "buy-now-btn" || (event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.id) === "buy-now-label") {
      props.ctaHandler(props.item);
    } else if ((event === null || event === void 0 ? void 0 : (_event$target3 = event.target) === null || _event$target3 === void 0 ? void 0 : _event$target3.id) !== "checkbox" && (event === null || event === void 0 ? void 0 : (_event$target4 = event.target) === null || _event$target4 === void 0 ? void 0 : _event$target4.tagName) !== "BUTTON" && (event === null || event === void 0 ? void 0 : (_event$target5 = event.target) === null || _event$target5 === void 0 ? void 0 : _event$target5.id) !== "addToCompare" && (event === null || event === void 0 ? void 0 : (_event$target6 = event.target) === null || _event$target6 === void 0 ? void 0 : _event$target6.id) !== "close" && (event === null || event === void 0 ? void 0 : (_event$target7 = event.target) === null || _event$target7 === void 0 ? void 0 : _event$target7.tagName) !== "SPAN") {
      props.ctaHandler(props.item);
      (0,helperServices/* showSpinner */.yh)();
      var routerObj = isMonthly && !props.isPrepaidOnly ? {
        pathname: "".concat(urlPrefix, "/product-details/").concat(props.sku),
        query: {
          monthlyPrice: true
        }
      } : {
        pathname: "".concat(urlPrefix, "/product-details/").concat(props.sku)
      };
      router.push(routerObj).then(function () {
        window.scrollTo(0, 0);
      });
    }
  };

  var handleSnackBar = function handleSnackBar() {
    setShowSnackBar(false);
  };

  setTimeout(function () {
    handleSnackBar();
  }, 3000);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [showSnackBar && /*#__PURE__*/(0,jsx_runtime.jsx)(SnackBar["default"], {
      message: labels/* default.lbl_cart_item */.Z.lbl_cart_item,
      className: (ProductCards_module_default()).snackBarSpacing,
      closeSnackBar: handleSnackBar,
      isVisible: showSnackBar
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
      className: "".concat(props !== null && props !== void 0 && props.finalPriceReq && props !== null && props !== void 0 && props.amountOff ? "".concat((ProductCards_module_default()).price_promotion) : "".concat((ProductCards_module_default()).regular_product)),
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, (_jsxs2 = {
        style: {
          width: !props.isMobile && props.cardWidth,
          minWidth: !props.isMobile && (props === null || props === void 0 ? void 0 : props.cardMinWidth),
          minHeight: !props.isMobile ? !props.finalPriceReq ? props.cardHeight : props === null || props === void 0 ? void 0 : props.cardHeightForOffer : "auto"
        },
        id: "".concat(props === null || props === void 0 ? void 0 : props.id, "-product-card"),
        className: "".concat((ProductCards_module_default())["Product-Card"], " ").concat(props === null || props === void 0 ? void 0 : props.className, " ").concat(props === null || props === void 0 ? void 0 : props.customStyle, " ").concat(isAddedForCompare ? "".concat((ProductCards_module_default())["product-card-selected"]) : "", "\n\t\t\t\t").concat(dealVariant && isTimerOn && (dealVariant == "locked" || dealVariant == "hidden") ? "".concat((ProductCards_module_default())["product-card-non-clickable"]) : "", "\n\t\t\t"),
        onClick: !props.addToCart ? function (event) {
          return onProductClick(event);
        } : undefined
      }, (0,defineProperty/* default */.Z)(_jsxs2, "id", "".concat(props.sku, "-productcard")), (0,defineProperty/* default */.Z)(_jsxs2, "children", [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        children: props !== null && props !== void 0 && props.closeButtonReq ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: (ProductCards_module_default())["close-button"],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            removeIdClose: props.sku,
            id: "close",
            className: "".concat((ProductCards_module_default())["compare-product-close"], "  mt-xs mr-xs pt-m float-right"),
            onClick: function onClick() {
              return props === null || props === void 0 ? void 0 : props.handleClose(props.item);
            }
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: !props.isMobile || props.promotionLabel !== "" || props !== null && props !== void 0 && props.isLowStock || props !== null && props !== void 0 && props.isOutOfStock || (props === null || props === void 0 ? void 0 : props.amountOff) !== "0" ? "".concat((ProductCards_module_default())["top-section"], " d-flex justify-content-between  align-items-center  pl-xs pr-xs ") : "".concat((ProductCards_module_default())["top-section-without-tag"]),
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "\n                  ".concat((ProductCards_module_default())["promotion-text-container"], "\n                  ").concat(!(props !== null && props !== void 0 && props.isOutOfStock) && !props.promotionVariant && (ProductCards_module_default()).extra_space_align),
            children: [props.promotionText && /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
              className: (ProductCards_module_default())["promotion-text"],
              children: props.promotionText
            }), (props === null || props === void 0 ? void 0 : props.finalPriceReq) && (props === null || props === void 0 ? void 0 : props.amountOff) && /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
              className: (ProductCards_module_default())["promotion-text"],
              children: ["SAVE R", (0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.amountOff))]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((ProductCards_module_default())["spacing-label"], " "),
            children: [props.promotionLabel !== "" && !(props !== null && props !== void 0 && (_props$item19 = props.item) !== null && _props$item19 !== void 0 && _props$item19.promotion_tag) && (!props.isLowStock || props !== null && props !== void 0 && props.isLowStock && (props === null || props === void 0 ? void 0 : (_props$item20 = props.item) === null || _props$item20 === void 0 ? void 0 : _props$item20.display_low_stock_badge) == 0) && !props.isOutOfStock && (props === null || props === void 0 ? void 0 : (_props$item21 = props.item) === null || _props$item21 === void 0 ? void 0 : _props$item21.promotion_tag) !== null ? /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
              label: props === null || props === void 0 ? void 0 : props.promotionLabel,
              variant: props === null || props === void 0 ? void 0 : props.promotionVariant,
              labelColor: props === null || props === void 0 ? void 0 : props.promotionLabelColor,
              className: props === null || props === void 0 ? void 0 : props.offerStyle
            }) : '', !props.isOutOfStock && (props === null || props === void 0 ? void 0 : props.isLowStock) && (props === null || props === void 0 ? void 0 : (_props$item22 = props.item) === null || _props$item22 === void 0 ? void 0 : _props$item22.display_low_stock_badge) == 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
              variant: "low-stock",
              className: props === null || props === void 0 ? void 0 : props.offerStyle
            }), (props === null || props === void 0 ? void 0 : props.isOutOfStock) && /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
              variant: "no-stock",
              className: props === null || props === void 0 ? void 0 : props.offerStyle
            })]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
        className: props.isMobile ? "d-flex ".concat((ProductCards_module_default()).mobile_product_info_contaier) : "".concat((ProductCards_module_default()).product_info_contaier),
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: " ".concat((ProductCards_module_default())["Image-section"], " ").concat(props === null || props === void 0 ? void 0 : props.styleImageSection, " "),
          children: [props.isMobile ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
              img_path: props === null || props === void 0 ? void 0 : props.itemImage,
              img_width: props !== null && props !== void 0 && props.imgWidthMobile ? props === null || props === void 0 ? void 0 : props.imgWidthMobile : "5.31rem",
              img_height: "5.625rem"
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (ProductCards_module_default()).imageWithTextContainer,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ImageWithText/* default */.Z, {
              imageLabelStyle: "".concat((ProductCards_module_default())["image-text-content"], " ").concat((ProductCards_module_default())["bottom-align"], " ").concat(props === null || props === void 0 ? void 0 : props.labelStyle),
              text: props.itemName,
              img_path: props === null || props === void 0 ? void 0 : props.itemImage,
              width: props.imgWidth,
              height: props.imgHeight,
              uniqueName: "".concat(props.sku, "-").concat(props.itemName)
            })
          }), dealVariant && dealVariant != "locked" && isTimerOn ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((ProductCards_module_default())["timer-section"], " ").concat((ProductCards_module_default())[dealVariant === "specialDeals" && "timer-section-background"]),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              style: {
                backgroundColor: dealVariant === "specialDeals" ? props === null || props === void 0 ? void 0 : props.endsIn : props === null || props === void 0 ? void 0 : props.availableIn
              },
              className: (ProductCards_module_default())["timer-inner"],
              id: "".concat(props === null || props === void 0 ? void 0 : props.deal_label, "-PC-container"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: (ProductCards_module_default())["timer-text"],
                id: "".concat(props === null || props === void 0 ? void 0 : props.deal_label, "-PC-text"),
                children: props === null || props === void 0 ? void 0 : props.deal_label
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Timer/* default */.Z, {
                dateTime: dateTime,
                onTimerComplete: handleTimerChange
              })]
            })
          }) : ""]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "description ".concat((ProductCards_module_default())["description-section"]),
          children: [props.isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((ProductCards_module_default())["mobile-label"], " ").concat(props === null || props === void 0 ? void 0 : props.mobileLabelClassName),
            style: {
              minHeight: props === null || props === void 0 ? void 0 : props.mobileLabelMinHeight
            },
            children: props.itemName
          }), ((props === null || props === void 0 ? void 0 : props.showColorSwatch) === undefined || (props === null || props === void 0 ? void 0 : props.showColorSwatch)) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: (ProductCards_module_default()).color_swatch_container,
              children: colorAvailable
            })
          }), (props === null || props === void 0 ? void 0 : props.switchReq) && !props.isMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((ProductCards_module_default())["spacing-switch"], " ").concat(props !== null && props !== void 0 && props.hideSwitching ? "d-none" : "d-none", " pt-m"),
            children: props !== null && props !== void 0 && props.isPrepaidOnly ? /*#__PURE__*/(0,jsx_runtime.jsx)(infoText_InfoText, {
              text: labels/* default.lbl_once_off_only */.Z.lbl_once_off_only
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(switch_Switch, {
              handleFirst: btnfClicked,
              handleSecond: btnsClicked,
              btnfColor: isMonthly,
              btnSColor: isOnceOff,
              variant: props !== null && props !== void 0 && props.switchClass ? props === null || props === void 0 ? void 0 : props.switchClass : ""
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (ProductCards_module_default()).pricing_section,
            children: [!(props !== null && props !== void 0 && props.isPrepaidOnly) && (props === null || props === void 0 ? void 0 : props.dealProductPrice) && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((ProductCards_module_default())["final-price-monthly"], " ").concat((props === null || props === void 0 ? void 0 : props.finalPriseAlignmiddle) === true ? "text-center" : ""),
              id: "".concat(props.sku, "-FinalPrice"),
              children: ["from ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                children: ["R" + (0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.dealProductPrice)), " PM"]
              })]
            }), !props.isMobile && (props === null || props === void 0 ? void 0 : props.finalPriceReq) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "".concat((ProductCards_module_default())["offer-price-box"], " ").concat(props === null || props === void 0 ? void 0 : props.offerPriceClass, " ").concat((props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && (ProductCards_module_default()).single_price_text, " "),
                children: !props.showPriceInLine ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                    className: !props.previousPriceReq ? "d-none" : (ProductCards_module_default())["previous-price"],
                    id: "".concat(props.sku, "-PreviousPrice"),
                    children: [!(props !== null && props !== void 0 && props.isPrepaidOnly) && props !== null && props !== void 0 && props.dealProductPrice ? "or for " : "for ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                      children: ["R", (0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice))]
                    })]
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                    id: "".concat(props.sku, "-FinalPrice"),
                    className: "".concat((ProductCards_module_default())["final-price"], " ").concat(props === null || props === void 0 ? void 0 : props.finalPriceClassLabel),
                    children: [" R", (0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.finalPrice))]
                  })]
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (ProductCards_module_default())["single-line-price-box"],
                  id: "".concat(props.sku, "-SinglePrice"),
                  children: [checked ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (ProductCards_module_default()).offerPrice,
                    children: "+"
                  }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (ProductCards_module_default())["final-price"],
                    id: props.sku,
                    children: "R" + (0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.finalPrice))
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: (ProductCards_module_default())["previous-price"],
                    children: " R" + (0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice))
                  })]
                })
              }), (props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "".concat((ProductCards_module_default()).once_off_only_text),
                children: "once-off only"
              })]
            }), (props === null || props === void 0 ? void 0 : props.priceRequired) && !props.finalPriceReq && !props.isMobile && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              id: "".concat(props.sku, "-PriceLabel"),
              className: "\n                  ".concat((ProductCards_module_default())["price-label"], "\n                  ").concat(props.isMobile ? "text-left" : "text-center", "\n                  ").concat(props !== null && props !== void 0 && props.priceLabelClassName ? props === null || props === void 0 ? void 0 : props.priceLabelClassName : "", "\n                  ").concat(!(props !== null && props !== void 0 && props.isPrepaidOnly) ? (ProductCards_module_default()).regular_prices_styles : "", "\n                  "),
              children: [!props.showPriceInLine && (isOnceOff || (props === null || props === void 0 ? void 0 : props.isPrepaidOnly)) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [!(props !== null && props !== void 0 && props.isPrepaidOnly) && (props === null || props === void 0 ? void 0 : props.dealProductPrice) && "or ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (ProductCards_module_default()).hide_in_mobile_only,
                  children: "for "
                }), " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [" R", (0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice))]
                })]
              }), (props === null || props === void 0 ? void 0 : props.showPriceInLine) && checked && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (ProductCards_module_default()).regularPrice,
                children: ["+ R", (0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice))]
              }), (props === null || props === void 0 ? void 0 : props.showPriceInLine) && !checked && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                className: (ProductCards_module_default()).regularPrice,
                children: ["R", (0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice))]
              }), (props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "".concat((ProductCards_module_default()).once_off_only_text),
                children: "once-off only"
              })]
            })]
          }), !props.checkRequired && (props === null || props === void 0 ? void 0 : props.switchReq) && props.isMobile && !props.isPrepaidOnly && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            id: "".concat(props.sku, "-PriceLabel"),
            className: "".concat((ProductCards_module_default())["price-label"], " ").concat(props.isMobile ? "text-left" : "text-center", "  "),
            children: "from R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.dealProductPrice)), " PM")
          }), !props.checkRequired && props.isMobile && (props === null || props === void 0 ? void 0 : props.priceRequired) && !props.finalPriceReq && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: "".concat((ProductCards_module_default())["special-price"], "\n\t\t\t\t\t\t\t\t\t").concat(props !== null && props !== void 0 && props.priceTextSpacingTopMobile ? props === null || props === void 0 ? void 0 : props.priceTextSpacingTopMobile : "mt-xs", " ").concat(props !== null && props !== void 0 && props.isPrepaidOnly ? (ProductCards_module_default())["price-bold"] : ""),
            children: [(props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && "for R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice))), !props.isPrepaidOnly && "or for R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice)))]
          }), (props === null || props === void 0 ? void 0 : props.checkRequired) && props.isMobile && props.priceRequired && !props.finalPriceReq && /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
            className: (props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && "mt-xs",
            children: [(props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (ProductCards_module_default())["once-off-mobile-text"],
                children: "for "
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (ProductCards_module_default())["price-bold-mobile"],
                children: "R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice)))
              })]
            }), !props.isPrepaidOnly && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "".concat((ProductCards_module_default())["monthly-mobile-text"], " ").concat((ProductCards_module_default()).regular_prices_styles),
              children: "or for R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice)))
            }), (props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "".concat((ProductCards_module_default()).once_off_only_text),
              children: "once-off only"
            })]
          }), !props.checkRequired && props.isMobile && (props === null || props === void 0 ? void 0 : props.previousPriceReq) && (props === null || props === void 0 ? void 0 : props.finalPriceReq) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((ProductCards_module_default())["special-price"], "\n\t\t\t\t\t\t\t\t\t").concat(props !== null && props !== void 0 && props.priceTextSpacingTopMobile ? props === null || props === void 0 ? void 0 : props.priceTextSpacingTopMobile : "mt-xs"),
              id: "".concat(props.sku, "-SpecialPrice"),
              children: [!props.isPrepaidOnly ? "or for " : "for ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (ProductCards_module_default())["final-price"],
                children: "R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.finalPrice)), " ")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (ProductCards_module_default())["previous-price"],
                children: "R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice)))
              })]
            })
          }), (props === null || props === void 0 ? void 0 : props.checkRequired) && (props === null || props === void 0 ? void 0 : props.isMobile) && (props === null || props === void 0 ? void 0 : props.previousPriceReq) && (props === null || props === void 0 ? void 0 : props.finalPriceReq) && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: "".concat((ProductCards_module_default())["special-price"], " ").concat(props.isPrepaidOnly && (ProductCards_module_default())["once-of-styles"]),
              id: "".concat(props.sku, "-SpecialPrice"),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (ProductCards_module_default())["monthly-mobile-text"],
                children: !props.isPrepaidOnly ? "or for " : "for "
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (ProductCards_module_default())["previous-price"],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  children: "R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props.minimumPrice)))
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: !props.isPrepaidOnly ? (ProductCards_module_default())["monthly-mobile-text"] : (ProductCards_module_default())["once-off-mobile-final-price-text"]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: !props.isPrepaidOnly ? (ProductCards_module_default())["final-price-with-monthly"] : (ProductCards_module_default())["final-price-mobile"],
                children: "R".concat((0,helperServices/* numberFormat */.i8)(Math.round(props === null || props === void 0 ? void 0 : props.finalPrice)), " ")
              }), (props === null || props === void 0 ? void 0 : props.isPrepaidOnly) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                className: "".concat((ProductCards_module_default()).once_off_only_text),
                children: "once-off only"
              })]
            })
          })]
        })]
      }), props.checkBoxReq && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: (ProductCards_module_default())["spacing-checkmark-previous"],
        children: props.isAddtoCompare ? /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          id: "addToCompare",
          customSelectStyle: true,
          isChecked: isAddedForCompare,
          isHidden: !showCompareCheck,
          check: "".concat(isAddedForCompare ? "".concat(props.checkedLabel) : "".concat(props.uncheckedLabel)),
          click: function click(event, flag) {
            return checkValidation(event, flag);
          },
          uniqueCheckId: props.sku,
          checkBoxLabelStyling: props === null || props === void 0 ? void 0 : props.checkBoxClassName
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
          largerCheckSize: props.largerCheckSize,
          id: "checkbox",
          customSelectStyle: props.customSelectStyle,
          isChecked: checked,
          check: "".concat(checked ? "".concat(props.checkedLabel) : "".concat(props.uncheckedLabel)),
          click: checkBoxHandler,
          uniqueCheckId: props.sku
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((ProductCards_module_default())[props === null || props === void 0 ? void 0 : props.footerSectionClassName], " footer-section"),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: "d-flex",
          children: [props.isMobile && props.checkBoxReq && showCompareCheck && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            id: "addToCompare",
            className: "".concat((ProductCards_module_default())["spacing-button"], "\n\t\t\t\t\t\t\t\t\t").concat((ProductCards_module_default())[props === null || props === void 0 ? void 0 : props.spacingButtonMobileClassName], "\n\t\t\t\t\t\t\t\t border-right d-none"),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              id: "addToCompare",
              className: (ProductCards_module_default())["addition-style"],
              children: [(props === null || props === void 0 ? void 0 : props.checkRequired) && isAddedForCompare && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
                id: "addToCompare",
                className: "".concat((ProductCards_module_default())["addToCompare-icon"], " mr-xs-l"),
                img_path: "".concat(imagePrefix, "/assets/images/success-copy-black.svg")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, {
                id: "addToCompare",
                uniqueButtonId: "".concat(props.sku, "-").concat(props.itemName, "-addToCompare"),
                isHidden: !showCompareCheck,
                selected: isAddedForCompare,
                selectedText: labels/* default.lbl_added_to_compare */.Z.lbl_added_to_compare,
                onBtnClick: function onBtnClick() {
                  return checkValidation(null, !isAddedForCompare);
                },
                text: labels/* default.lbl_add_to_compare */.Z.lbl_add_to_compare,
                textClassName: props.isMobile ? "btnTextSizingMobile" : ""
              })]
            })
          }), (props === null || props === void 0 ? void 0 : props.buyNowReq) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Link, {
            href: isMonthly && !props.isPrepaidOnly ? "".concat(urlPrefix, "/product-details/").concat(props.sku, "?monthlyPrice=true") : "".concat(urlPrefix, "/product-details/").concat(props.sku),
            legacyBehavior: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (ProductCards_module_default())["buy-now-btn"],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
                id: "buy-now-button",
                className: "".concat((ProductCards_module_default())["spacing-button"], "\n                    ").concat(props !== null && props !== void 0 && props.buttonStyleRequired ? (ProductCards_module_default())["button-position"] : "", " ").concat(props === null || props === void 0 ? void 0 : props.buttonClassName, "\n\t\t\t\t\t\t\t\t").concat((ProductCards_module_default())[props === null || props === void 0 ? void 0 : props.spacingButtonMobileClassName]),
                children: props.promotionLabel === types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, {
                  text: labels/* default.lbl_preorder_now */.Z.lbl_preorder_now,
                  textClassName: props.isMobile ? "btnTextSizingMobile" : "",
                  pageRequired: "product-details"
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
                  className: (ProductCards_module_default())["addition-style"],
                  children: [(props === null || props === void 0 ? void 0 : props.additionRequired) && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
                    className: "mr-ss",
                    img_path: "".concat(imagePrefix, "/assets/images/add-copy.svg"),
                    img_width: "16px",
                    Height: "16px"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "".concat((ProductCards_module_default())["buy-now-label"], " \n\t\t\t\t\t\t\t\t\t\t\t\t\t").concat((ProductCards_module_default())[dealVariant === "hidden" ? "hidden-label" : ""], "\n\t\t\t\t\t\t\t\t\t\t\t\t\t").concat((ProductCards_module_default())[props !== null && props !== void 0 && props.isMobile && props !== null && props !== void 0 && props.checkBoxReq ? "buy-now-text-sizing-mobile" : ""], " "),
                    id: "buy-now-label",
                    children: props.buttonLabelReq
                  })]
                })
              })
            })
          }), (props === null || props === void 0 ? void 0 : props.addToCart) && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "".concat((ProductCards_module_default())["spacing-button"], " ").concat(props["cart-btn-Spacing"], " ").concat(props === null || props === void 0 ? void 0 : props.buttonClassName, " ").concat((props === null || props === void 0 ? void 0 : props.amountOff) === "0" ? (ProductCards_module_default())["amount-off-space"] : (ProductCards_module_default())["button-off-space"], "  ").concat((ProductCards_module_default())[props === null || props === void 0 ? void 0 : props.spacingButtonMobileClassName]),
            children: props.promotionLabel === types/* default.TYPE_PREORDER */.Z.TYPE_PREORDER ? /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, {
              id: "".concat(props.sku, "-").concat(labels/* default.lbl_add_to_cart */.Z.lbl_add_to_cart),
              text: labels/* default.lbl_add_to_cart */.Z.lbl_add_to_cart,
              textClassName: props.isMobile ? "btnTextSizingMobile" : ""
            }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
              className: (ProductCards_module_default())["addition-style"],
              id: "".concat(props.sku, "-").concat(props.buttonLabelReq),
              children: [(props === null || props === void 0 ? void 0 : props.additionRequired) && /*#__PURE__*/(0,jsx_runtime.jsx)(image_image["default"], {
                className: (ProductCards_module_default())["add-img-spacing"],
                img_path: (0,helperServices/* checkIsOutOfStock */.zy)(props === null || props === void 0 ? void 0 : props.item) ? "".concat(imagePrefix, "/assets/images/add-copy-disabled.svg") : "".concat(imagePrefix, "/assets/images/add-copy.svg"),
                img_width: "16px",
                Height: "16px"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, {
                button: true,
                text: props.buttonLabelReq,
                textClassName: props.isMobile ? "btnTextSizingMobile" : "",
                onBtnClick: addCookieProductToCart,
                disabledBtnClassName: (0,helperServices/* checkIsOutOfStock */.zy)(props === null || props === void 0 ? void 0 : props.item) ? "out-of-stock-disabled-btn" : "",
                disabledFlag: (0,helperServices/* checkIsOutOfStock */.zy)(props === null || props === void 0 ? void 0 : props.item)
              })]
            })
          })]
        })
      }), dealVariant && dealVariant == "locked" && isTimerOn ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "".concat((ProductCards_module_default())["timer-section"], " ").concat((ProductCards_module_default())["locked-timer"]),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
          className: (ProductCards_module_default())["timer-inner"],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (ProductCards_module_default())["timer-lock-image"],
            id: "timerLock-image-PC"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: (ProductCards_module_default())["timer-text"],
            id: "".concat(props === null || props === void 0 ? void 0 : props.deal_label, "-locked-PC-text"),
            children: props === null || props === void 0 ? void 0 : props.deal_label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Timer/* default */.Z, {
            dateTime: dateTime,
            onTimerComplete: handleTimerChange
          })]
        })
      }) : ""]), _jsxs2))
    })]
  });
};

ProductCards.defaultProps = {
  isMonthly: false,
  isOnceOff: true,
  onPriceTypeChange: function onPriceTypeChange() {},
  ctaHandler: function ctaHandler() {}
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    productCompareList: state.productCompare.productCompareList,
    totalQuantity: state.cartDetails.totalQuantity,
    userProfileSync: state.userProfileSync
  };
};

/* harmony default export */ var ProductCards_ProductCards = ((0,DependencyHelper.connect)(mapStateToProps, {
  addRemoveProductToCompare: productCompareAction/* addRemoveProductToCompare */.vH,
  showCompareError: productCompareAction/* showCompareError */.EQ,
  addSimpleProductToGuestCart: cartAction/* addSimpleProductToGuestCart */.a1,
  addConfigurableToGuestCart: cartAction/* addConfigurableToGuestCart */.bc,
  addBundleProductToGuestCart: cartAction/* addBundleProductToGuestCart */.HJ,
  syncUserProfile: userProfileAction/* syncUserProfile */.c,
  resetSyncUserProfile: userProfileAction/* resetSyncUserProfile */.h
})(ProductCards));

/***/ }),

/***/ 98776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tG": function() { return /* binding */ getAllCategories; },
  "iK": function() { return /* binding */ getProductCompareList; },
  "qZ": function() { return /* binding */ getProductSearchList; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
;// CONCATENATED MODULE: ./config/keysMap.js
var keysMap = {
  sku: 'SKU',
  price: 'Price',
  description: 'Description',
  short_description: 'Short Description',
  accessories_01: 'Accessory 01',
  accessories_02: 'Accessory 02',
  primary_camera: 'Primary Camera',
  manufacturer: 'Brand',
  battery_capacity: 'Battery Capacity',
  secondary_camera: 'Secondary Camera'
};
/* harmony default export */ var config_keysMap = (keysMap);
;// CONCATENATED MODULE: ./services/productListService.js




function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




var getAllCategories = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var isDealPage,
        categoryId,
        dealCategoryId,
        result,
        categories,
        _iterator,
        _step,
        item,
        categoryObj,
        _iterator2,
        _step2,
        childrenItem,
        subCategoryObj,
        _result$category,
        totalCatCount,
        dealIndex,
        totalDealcount,
        _args = arguments;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isDealPage = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
            categoryId = _args.length > 1 ? _args[1] : undefined;
            dealCategoryId = _args.length > 2 ? _args[2] : undefined;
            _context.next = 5;
            return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(queries/* Categories */.Rj, {
              id: categoryId
            });

          case 5:
            result = _context.sent;
            categories = [];

            if (result && result.category && result.category.children) {
              _iterator = _createForOfIteratorHelper(result.category.children);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  categoryObj = {
                    id: item.id,
                    name: item.name,
                    short_description: item.short_description,
                    imageUrl: item.image && item.image.replace(/www/gi, "shop"),
                    activeImageUrl: item.hover_image_url,
                    count: item.product_total_count && item.product_total_count,
                    position: item.position
                  };
                  categoryObj.subCategories = [];
                  _iterator2 = _createForOfIteratorHelper(item.children);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      childrenItem = _step2.value;
                      subCategoryObj = {
                        id: childrenItem.id,
                        name: childrenItem.name,
                        short_description: item.short_description,
                        imageUrl: childrenItem.image && childrenItem.image.replace(/www/gi, "shop"),
                        activeImageUrl: item.hover_image_url,
                        count: childrenItem.product_total_count && childrenItem.product_total_count,
                        position: childrenItem.position
                      };
                      categoryObj.subCategories.push(subCategoryObj);
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }

                  categories.push(categoryObj);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }

            if (!isDealPage && categories) {
              totalCatCount = result === null || result === void 0 ? void 0 : (_result$category = result.category) === null || _result$category === void 0 ? void 0 : _result$category.product_total_count;
              dealIndex = categories.findIndex(function (item) {
                return item.id === parseInt(dealCategoryId);
              });

              if (dealIndex !== -1) {
                totalDealcount = categories[dealIndex].count;
                result.category.product_total_count = totalCatCount > 0 ? totalCatCount - totalDealcount : 0;
                categories.splice(dealIndex, 1);
              }
            }

            return _context.abrupt("return", {
              categories: categories,
              totalProducts: result && result.category && result.category.product_total_count ? result.category.product_total_count : 0,
              status: result === null || result === void 0 ? void 0 : result.status,
              errors: result === null || result === void 0 ? void 0 : result.errors
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getAllCategories() {
    return _ref.apply(this, arguments);
  };
}();
var getProductCompareList = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(skus) {
    var result, compareProductsData, _iterator3, _step3, _loop;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(queries/* CompareProducts */.vn, {
              skus: skus
            });

          case 2:
            result = _context2.sent;
            compareProductsData = [];

            if (result && result.productCompare && result.productCompare.allProducts && result.productCompare.allProducts.length) {
              _iterator3 = _createForOfIteratorHelper(result.productCompare.allProducts);

              try {
                _loop = function _loop() {
                  var item = _step3.value;
                  var parsedDataObj = JSON.parse(item.data);
                  var compareObj = {};
                  Object.entries(parsedDataObj).map(function (_ref3) {
                    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
                        parentKey = _ref4[0],
                        parentValue = _ref4[1];

                    compareObj[parentKey] = {};
                    Object.entries(parentValue).map(function (_ref5) {
                      var _ref6 = (0,slicedToArray/* default */.Z)(_ref5, 2),
                          childKey = _ref6[0],
                          childValue = _ref6[1];

                      var _keys = Object.keys(config_keysMap);

                      if (_keys.indexOf(childKey) >= 0) {
                        compareObj[parentKey][config_keysMap[childKey]] = childValue;
                      } else {
                        compareObj[parentKey][childKey] = childValue;
                      }
                    });
                  });
                  compareObj.image = item.image;
                  compareObj.name = item.name;
                  compareObj.sku = item.sku;
                  compareProductsData.push(compareObj);
                };

                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _loop();
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
            } else {
              compareProductsData = [];
            }

            return _context2.abrupt("return", compareProductsData);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getProductCompareList(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getProductSearchList = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(key, category_id, signal) {
    var result, searchList, _iterator4, _step4, item, searchItemsObj;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(category_id !== -1)) {
              _context3.next = 6;
              break;
            }

            _context3.next = 3;
            return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(queries/* ProductSearchList */.Je, {
              key: key,
              id: category_id
            }, signal);

          case 3:
            result = _context3.sent;
            _context3.next = 9;
            break;

          case 6:
            _context3.next = 8;
            return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(queries/* ProductSearchtWithoutCategoryList */.U2, {
              key: key
            }, signal);

          case 8:
            result = _context3.sent;

          case 9:
            searchList = [];

            if (result && result.products && result.products.items) {
              _iterator4 = _createForOfIteratorHelper(result.products.items);

              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  item = _step4.value;
                  searchItemsObj = {
                    name: item.name,
                    image: item.small_image,
                    sku: item.sku,
                    item: item
                  };
                  searchList.push(searchItemsObj);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
            }

            return _context3.abrupt("return", searchList);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getProductSearchList(_x2, _x3, _x4) {
    return _ref7.apply(this, arguments);
  };
}();

/***/ }),

/***/ 51494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"info-container":"InfoText_info-container__rd1AG","info-text":"InfoText_info-text__YXeMi"};

/***/ }),

/***/ 24236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"regular-switch":"Switch_regular-switch__eIPJ3","first-btn":"Switch_first-btn__F1GVa","btn-group":"Switch_btn-group__nlPd_","btn-clicked":"Switch_btn-clicked__ZjWqv","btn-not-clicked":"Switch_btn-not-clicked__iYy8P","second-btn":"Switch_second-btn__EOwtQ","product-list-switch":"Switch_product-list-switch__OU3SY","regular-switch--product-carousel":"Switch_regular-switch--product-carousel__rNHtv"};

/***/ }),

/***/ 57922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"p-xxs":"ProductCards_p-xxs__op9cR","pl-xxs":"ProductCards_pl-xxs__cOB5A","pr-xxs":"ProductCards_pr-xxs__DZ3Zz","pb-xxs":"ProductCards_pb-xxs__AWzMv","pt-xxs":"ProductCards_pt-xxs__C2XUF","m-xxs":"ProductCards_m-xxs__r6auX","ml-xxs":"ProductCards_ml-xxs__v_ZLt","mr-xxs":"ProductCards_mr-xxs__1Q1F8","mb-xxs":"ProductCards_mb-xxs__IY367","mt-xxs":"ProductCards_mt-xxs__rnkxr","px-xxs":"ProductCards_px-xxs__F6Mnc","mx-xxs":"ProductCards_mx-xxs__dbsQ3","my-xxs":"ProductCards_my-xxs__ih6h0","py-xxs":"ProductCards_py-xxs__LQ0re","font-size-xxs":"ProductCards_font-size-xxs__DFHr7","p-xs":"ProductCards_p-xs__98k2q","pl-xs":"ProductCards_pl-xs__YWcrg","pr-xs":"ProductCards_pr-xs__vnbs_","pb-xs":"ProductCards_pb-xs__3_V5s","pt-xs":"ProductCards_pt-xs__yLtbr","m-xs":"ProductCards_m-xs__c_u_k","ml-xs":"ProductCards_ml-xs__1QlWh","mr-xs":"ProductCards_mr-xs__j71sp","mb-xs":"ProductCards_mb-xs___N5qe","mt-xs":"ProductCards_mt-xs__i9HCZ","px-xs":"ProductCards_px-xs__UOes0","mx-xs":"ProductCards_mx-xs__asDp_","my-xs":"ProductCards_my-xs__xe4ei","py-xs":"ProductCards_py-xs__y7XNq","font-size-xs":"ProductCards_font-size-xs__6_G_E","p-ss":"ProductCards_p-ss___hqCe","pl-ss":"ProductCards_pl-ss__QSnXD","pr-ss":"ProductCards_pr-ss__0tA30","pb-ss":"ProductCards_pb-ss__kyVZ6","pt-ss":"ProductCards_pt-ss__XFhzb","m-ss":"ProductCards_m-ss__kZaak","ml-ss":"ProductCards_ml-ss__2I4DB","mr-ss":"ProductCards_mr-ss__WV02V","mb-ss":"ProductCards_mb-ss__Jb48F","mt-ss":"ProductCards_mt-ss__mJ8o1","px-ss":"ProductCards_px-ss__xEG2d","mx-ss":"ProductCards_mx-ss__xld1o","my-ss":"ProductCards_my-ss__RNkI_","py-ss":"ProductCards_py-ss__gy8iO","font-size-ss":"ProductCards_font-size-ss__JV2ar","p-ms":"ProductCards_p-ms__9dzne","pl-ms":"ProductCards_pl-ms__tn73Y","pr-ms":"ProductCards_pr-ms__zuqKj","pb-ms":"ProductCards_pb-ms__rYJFi","pt-ms":"ProductCards_pt-ms__h0NvK","m-ms":"ProductCards_m-ms__Tw8c3","ml-ms":"ProductCards_ml-ms__tTRSy","mr-ms":"ProductCards_mr-ms__Phxgy","mb-ms":"ProductCards_mb-ms__tWsao","mt-ms":"ProductCards_mt-ms__1tKdm","px-ms":"ProductCards_px-ms__Rylbs","mx-ms":"ProductCards_mx-ms___d6Y_","my-ms":"ProductCards_my-ms__QA_LZ","py-ms":"ProductCards_py-ms__njn5j","font-size-ms":"ProductCards_font-size-ms__MVPRF","p-s":"ProductCards_p-s__AYZDN","pl-s":"ProductCards_pl-s__22htb","pr-s":"ProductCards_pr-s__3Xg_w","pb-s":"ProductCards_pb-s__Up321","pt-s":"ProductCards_pt-s__hkREf","m-s":"ProductCards_m-s__QOafB","ml-s":"ProductCards_ml-s__7wwGF","mr-s":"ProductCards_mr-s__fSh3P","mb-s":"ProductCards_mb-s__bFoap","mt-s":"ProductCards_mt-s__dM4dK","px-s":"ProductCards_px-s__JIaJL","mx-s":"ProductCards_mx-s__iE1j2","my-s":"ProductCards_my-s__FXTxR","py-s":"ProductCards_py-s__UVjIu","font-size-s":"ProductCards_font-size-s__YEpQp","p-m":"ProductCards_p-m__J_bWT","pl-m":"ProductCards_pl-m__kbeze","pr-m":"ProductCards_pr-m__pvzdg","pb-m":"ProductCards_pb-m__9bbuv","pt-m":"ProductCards_pt-m__GpvPa","m-m":"ProductCards_m-m__IhBtm","ml-m":"ProductCards_ml-m__ngekX","mr-m":"ProductCards_mr-m___iZ3w","mb-m":"ProductCards_mb-m__8FJVV","mt-m":"ProductCards_mt-m__Oq5ky","px-m":"ProductCards_px-m__qXLG7","mx-m":"ProductCards_mx-m__YMEVV","my-m":"ProductCards_my-m__af7H2","py-m":"ProductCards_py-m__tfCVR","font-size-m":"ProductCards_font-size-m__kHlxd","p-l":"ProductCards_p-l__FLrbo","pl-l":"ProductCards_pl-l__udIIB","pr-l":"ProductCards_pr-l__iYssF","pb-l":"ProductCards_pb-l__zSLx8","pt-l":"ProductCards_pt-l__3TmgA","m-l":"ProductCards_m-l__O5mri","ml-l":"ProductCards_ml-l__lqYlY","mr-l":"ProductCards_mr-l__qVijt","mb-l":"ProductCards_mb-l__CzRlE","mt-l":"ProductCards_mt-l__z32VH","px-l":"ProductCards_px-l__NobAO","mx-l":"ProductCards_mx-l__pbd4g","my-l":"ProductCards_my-l__HLRhJ","py-l":"ProductCards_py-l__NLCxv","font-size-l":"ProductCards_font-size-l__60ogB","p-xl":"ProductCards_p-xl__5Rx_T","pl-xl":"ProductCards_pl-xl__NrmoG","pr-xl":"ProductCards_pr-xl__nCSnP","pb-xl":"ProductCards_pb-xl__WspgR","pt-xl":"ProductCards_pt-xl__AEGtu","m-xl":"ProductCards_m-xl__7V5IJ","ml-xl":"ProductCards_ml-xl___X69o","mr-xl":"ProductCards_mr-xl__g8GYg","mb-xl":"ProductCards_mb-xl__y_55L","mt-xl":"ProductCards_mt-xl__2n6oV","px-xl":"ProductCards_px-xl__n3eMZ","mx-xl":"ProductCards_mx-xl__XHzHs","my-xl":"ProductCards_my-xl__IbTO0","py-xl":"ProductCards_py-xl__KtkIr","font-size-xl":"ProductCards_font-size-xl__S9hAt","p-xxl":"ProductCards_p-xxl__tGsnF","pl-xxl":"ProductCards_pl-xxl__ViGCS","pr-xxl":"ProductCards_pr-xxl__yrmej","pb-xxl":"ProductCards_pb-xxl__jUYKy","pt-xxl":"ProductCards_pt-xxl__oWugf","m-xxl":"ProductCards_m-xxl__qY0zY","ml-xxl":"ProductCards_ml-xxl__eLW0o","mr-xxl":"ProductCards_mr-xxl__iro5c","mb-xxl":"ProductCards_mb-xxl__j7lSR","mt-xxl":"ProductCards_mt-xxl__Jm1X2","px-xxl":"ProductCards_px-xxl__GTFk2","mx-xxl":"ProductCards_mx-xxl__rya33","my-xxl":"ProductCards_my-xxl__hJksq","py-xxl":"ProductCards_py-xxl__mKkye","font-size-xxl":"ProductCards_font-size-xxl__Fs6x5","overflow-hidden":"ProductCards_overflow-hidden__wETUD","topMargin":"ProductCards_topMargin__FZj1c","Product-Card":"ProductCards_Product-Card__TAbQW","price_promotion":"ProductCards_price_promotion__9lGuq","product_info_contaier":"ProductCards_product_info_contaier__Mezsx","regular_product":"ProductCards_regular_product__5IEkx","mobile_product_info_contaier":"ProductCards_mobile_product_info_contaier__ZkU32","color_swatch_container":"ProductCards_color_swatch_container__BroLI","color_swatch":"ProductCards_color_swatch__vxaOI","single_price_text":"ProductCards_single_price_text__j_xsk","previous-price":"ProductCards_previous-price__IF7q0","final-price":"ProductCards_final-price___7hAC","final-price-mobile":"ProductCards_final-price-mobile__lCUVJ","snackBarSpacing":"ProductCards_snackBarSpacing__xgnJd","Image-section":"ProductCards_Image-section__bAZ3w","image-text-content":"ProductCards_image-text-content__ZaMYy","bottom-align":"ProductCards_bottom-align__BVP8L","promotion-text-container":"ProductCards_promotion-text-container__5W8u_","promotion-text":"ProductCards_promotion-text__AHVnt","regular_prices_styles":"ProductCards_regular_prices_styles__9W7py","price-label":"ProductCards_price-label__2HI9Q","price-bold":"ProductCards_price-bold__Zh6lV","price-bold-mobile":"ProductCards_price-bold-mobile__rlq0M","special-price":"ProductCards_special-price__3kSlt","monthly-mobile-text":"ProductCards_monthly-mobile-text__XQ9G5","once-of-styles":"ProductCards_once-of-styles__9Apr_","once-off-mobile-final-price-text":"ProductCards_once-off-mobile-final-price-text__RERn8","pricing_section":"ProductCards_pricing_section__ertsT","offer-price-box":"ProductCards_offer-price-box__PFTaE","once_off_only_text":"ProductCards_once_off_only_text__B7wJB","final-price-with-monthly":"ProductCards_final-price-with-monthly__bvfK1","once-off-mobile-text":"ProductCards_once-off-mobile-text__yve0B","custom-styles-carousel":"ProductCards_custom-styles-carousel__zSjm0","final-price-monthly":"ProductCards_final-price-monthly__atnLm","spacing-switch":"ProductCards_spacing-switch__iTGvC","spacing-checkmark":"ProductCards_spacing-checkmark__02FBy","spacing-checkmark-previous":"ProductCards_spacing-checkmark-previous__abV5F","compare-product-close":"ProductCards_compare-product-close__0AtV7","spacing-button":"ProductCards_spacing-button__W3Hrk","spacing-label":"ProductCards_spacing-label__6tIkG","mobile-label":"ProductCards_mobile-label__vGNhb","extra_space_align":"ProductCards_extra_space_align__PPvX3","top-section":"ProductCards_top-section__cPg9F","top-section-without-tag":"ProductCards_top-section-without-tag__bDQjh","addition-style":"ProductCards_addition-style__XN_02","add-img-spacing":"ProductCards_add-img-spacing__LxKQF","addToCompare-icon":"ProductCards_addToCompare-icon__MXQO4","button-style":"ProductCards_button-style__w_U3R","button-position":"ProductCards_button-position__XN4n4","amount-off-space":"ProductCards_amount-off-space__Nnomv","description-section":"ProductCards_description-section__HTTRc","close-button":"ProductCards_close-button__oyMC9","imageWithTextContainer":"ProductCards_imageWithTextContainer__Jv3oL","single-line-price-box":"ProductCards_single-line-price-box__nvS4E","offerPrice":"ProductCards_offerPrice__4Jx8A","regularPrice":"ProductCards_regularPrice__RYf_q","transparant-btn":"ProductCards_transparant-btn___Tp3l","product-card-non-clickable":"ProductCards_product-card-non-clickable__arxYB","timer-section":"ProductCards_timer-section__n6yuW","timer-section-background":"ProductCards_timer-section-background__jH95a","locked-timer":"ProductCards_locked-timer__ZNDNn","timer-inner":"ProductCards_timer-inner__Ytrua","timer-lock-image":"ProductCards_timer-lock-image__a3UfN","timer-text":"ProductCards_timer-text____oqH","spacing-button-mobile":"ProductCards_spacing-button-mobile__ej40D","recently-viewed-buyNow-btn":"ProductCards_recently-viewed-buyNow-btn__s2Nm8","product-button-background":"ProductCards_product-button-background__X1twp","buy-now-btn":"ProductCards_buy-now-btn__I1JlS","buy-now-label":"ProductCards_buy-now-label__iQvso","hidden-label":"ProductCards_hidden-label__9UtQA","buy-now-btn-spacing-top":"ProductCards_buy-now-btn-spacing-top__OjjQf","button-off-space":"ProductCards_button-off-space__IsHHK","buy-now-text-sizing-mobile":"ProductCards_buy-now-text-sizing-mobile__5KHBc","hide_in_mobile_only":"ProductCards_hide_in_mobile_only__6m3B0"};

/***/ })

}]);